import { Link } from "react-router-dom";
import { ArrowRight, RefreshCw } from "lucide-react";
import { Reveal } from "./Reveal";

export default function FinalCTA() {
  const saveScroll = () =>
    sessionStorage.setItem("cdm-scroll", String(window.scrollY));

  return (
    <section data-testid="final-cta-section" className="section-pad pt-0">
      <div className="container-x">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl border border-emerald-400/20 bg-gradient-to-b from-navy-800/80 to-navy-900/95 px-6 py-16 text-center sm:px-12 sm:py-20">
            <div
              aria-hidden="true"
              className="absolute -top-24 left-1/2 h-[300px] w-[520px] -translate-x-1/2 rounded-full bg-emerald-500/15 blur-[100px]"
            />
            <div className="bg-grid absolute inset-0" aria-hidden="true" />
            <div className="relative">
              <h2 className="mx-auto max-w-2xl font-display text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
                Ready to exchange <span className="text-gradient">USDT to INR</span>?
              </h2>
              <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-slate-400 sm:text-lg">
                Log in to create your exchange order and follow the guided payment
                instructions inside your account.
              </p>
              <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
                <Link
                  data-testid="start-exchange-btn"
                  to="/app"
                  onClick={saveScroll}
                  className="btn-primary px-8 py-4 text-base"
                >
                  Start Exchange
                  <ArrowRight className="h-5 w-5" />
                </Link>
                <Link
                  data-testid="exchange-usdt-btn"
                  to="/app"
                  onClick={saveScroll}
                  className="btn-outline px-8 py-4 text-base font-semibold"
                >
                  <RefreshCw className="h-5 w-5" />
                  Exchange USDT
                </Link>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
